<template>
  <Form ref="form" @submit="onSubmit">
    <div class="modal-header">
      <h4 class="modal-title">
        {{ $getLocaleMessage('buttons', 'updating') }} Fondeadora <strong>{{ this.financialFunder.referenceNumber }}</strong>
      </h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <div class="form-group">
          <label for="anchor">Nombre:</label>
          <Field v-model="financialFunder.anchor" type="text" class="form-control" name="anchor" placeholder="Nombre"
            rules="required|max:255" />
          <ErrorMessage name="anchor" class="input-error"></ErrorMessage>
        </div>
      </div>

      <div class="form-group">
        <div class="form-group">
          <label for="observations">Observaciones:</label>
          <Field v-model="financialFunder.observations" type="text" class="form-control" name="observations"
            placeholder="Observaciones" rules="max:500"/>
            <ErrorMessage name="observations" class="input-error"></ErrorMessage>
        </div>
      </div>

      <div class="form-group">
        <label for="statusId">Estatus:</label>
        <StatusSelect v-model="financialFunder.statusId" :name="'statusId'" :options="statusOptions"></StatusSelect>                
      </div>

    </div>
    <div class="modal-footer justify-content-between">
      <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $getLocaleMessage('buttons', 'cancel') }}</button>
      <PrimaryButton class="btn btn-primary" type="submit">
        {{ $getLocaleMessage('buttons', 'update') }}
      </PrimaryButton>
    </div>
  </Form>
</template>

<script>
import * as helper from '@/helpers';
import { mapState, mapActions } from 'pinia';
import { useFinancialFundersStore } from '@/pinia/financialFunders.module';
import { useStatusStore } from '@/pinia/status.module';
import FinancialFunder from '@/Models/FinancialFunder';

import StatusSelect from '@/Components/Selects/SelectField.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';

export default {
  components: {
    PrimaryButton,
    StatusSelect,
  },
  data() {
    return {
      financialFunder: new FinancialFunder(),
    }
  },
  mixins: [],
  props: {
    selectedRecord: {
      type: Object,
      default: () => new FinancialFunder(),
    }
  },
  emits: ['close-modal'],
  computed: {
    ...mapState(useStatusStore, ['getAllStatusByType']),
    statusOptions() {
      return helper.mapOptions(this.getAllStatusByType(1));
    },
  },
  methods: {
    ...mapActions(useFinancialFundersStore, ['updateFinancialFunder']),
    ...mapActions(useStatusStore, ['fetchStatus', 'setSelectedStatus']),
    onSubmit() {
      this.updateFinancialFunder(this.financialFunder);
      this.$refs.form.resetForm();
      this.closeModal();
    },
    closeModal() {
      this.$emit('close-modal');
    },
  },
  watch: {
    selectedRecord: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.financialFunder = newValue;
        }
      }
    }
  },
  created() {},
}
</script>